<div class="revenue-value-edit" [formGroup]="form">
  <mat-form-field class="revenue-value-field">
    <mat-label>{{ 'FRONTEND.SALES_UI.PRICING.PRICE' | translate }}</mat-label>
    <span matPrefix class="prefix">{{ currencySymbol }} &nbsp;</span>
    <input
      matInput
      #input
      formControlName="revenue"
      step="0.01"
      class="value"
      placeholder="{{ 'FRONTEND.SALES_UI.PRICING.PRICE' | translate }} *"
    />
    <mat-error *ngIf="form.controls.revenue.hasError('required')">
      {{ 'FRONTEND.SALES_UI.PRICING.REVENUE_REQUIRED' | translate }}
    </mat-error>
    <mat-error *ngIf="form.controls.revenue.hasError('min')">
      {{ 'FRONTEND.SALES_UI.PRICING.GREATER_THAN_OR_EQUAL_TO_ZERO' | translate }}
    </mat-error>
    <mat-error *ngIf="form.controls.revenue.hasError('pattern')">
      {{ 'FRONTEND.SALES_UI.PRICING.MUST_BE_NUM' | translate }}
    </mat-error>
  </mat-form-field>
  <mat-form-field class="revenue-period-field">
    <mat-label>
      {{ 'FRONTEND.SALES_UI.PRICING.PERIOD' | translate }}
    </mat-label>
    <mat-select
      class="selected-revenue-period"
      formControlName="period"
      placeholder="{{ 'FRONTEND.SALES_UI.PRICING.PERIOD' | translate }} *"
    >
      <ng-container *ngIf="canEditPeriod">
        <mat-option *ngFor="let option of periodOptions" [value]="option.value">
          {{ option.label | translate }}
        </mat-option>
      </ng-container>
      <ng-container *ngIf="!canEditPeriod">
        <mat-option *ngFor="let option of oneTimeOnly" [value]="option.value">
          {{ option.label | translate }}
        </mat-option>
      </ng-container>
    </mat-select>
    <mat-error *ngIf="form.controls.period.hasError('required')">
      {{ 'FRONTEND.SALES_UI.PRICING.PERIOD_REQUIRED' | translate }}
    </mat-error>
  </mat-form-field>
  <span class="delete-icon">
    <button *ngIf="allowDelete" mat-button color="warn" (click)="handleDelete()" class="mobile-delete">
      {{ 'FRONTEND.SALES_UI.REMOVE' | translate }}
    </button>
  </span>
</div>
